<template>
  <div>
    <h1>Urlaub Hinzufügen</h1>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <div v-if="adminAccess">
            <label class="control-label col-md-12">Employee Name</label>
            <select
              v-if="employeesLoaded"
              v-model="leave.empId"
              class="form-control"
            >
              <option
                v-for="employee in employees"
                v-bind:value="employee.id"
                :key="employee.id"
              >
                {{ employee.name }}
              </option>
            </select>
          </div>
          <label class="control-label col-md-4">Beschreibung</label>
          <div class="col-md-8">
            <textarea v-model="leave.description" class="form-control" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label class="control-label col-md-4">Von</label>
          <div class="col-md-8">
            <datepicker v-model="leave.from" class="text-box single-line" />
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="control-label col-md-4">Bis</label>
          <div class="col-md-8">
            <datepicker v-model="leave.to" class="text-box single-line" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <a class="btn btn-success" @click="saveChanges">Speichern</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import moment from "moment";
import datepicker from "vuejs-datepicker";

export default {
  components: {
    datepicker,
  },
  name: "leaveCreate",
  data: function () {
    return {
      employees: [],
      employeesLoaded: false,
      minimumLeaveDate: moment().subtract(30, 'd'),
      leave: {
        empId: "",
        userId: "OverwrittenByBackend",
        from: moment().toString(),
        to: moment().toString(),
      },
    };
  },
  created: function () {},
  methods: {
    saveChanges: function (event) {
      console.log(this.leave);
      if (this.adminAccess === true) {
        this.leave.approved = true
      }
      //Send to server
      axios({
        method: "POST",
        url: process.env.VUE_APP_API_PATH + "leaves",
        data: this.leave,
      }).then(
        (result) => {
          //Changes have been saved
          this.$router.push("/leaves");
        },
        (error) => {
          //Changes have not been saved
          console.error(error);
        }
      );
    },
    loadComponentData: function () {
      // Load Employees
      axios({
        method: "GET",
        url: process.env.VUE_APP_API_PATH + "user/get",
      }).then(
        (result) => {
          this.employees = result.data.filter(d => (!d.leaveDate || d.leaveDate < this.minimumLeaveDate))
          this.employeesLoaded = true;
        },
        (error) => {
          this.employeesLoaded = false;
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        }
      );
    },
  },
  computed: {
      ...mapGetters(["isAuthenticated", "authStatus", "getProfile"]),
      ...mapState({
        adminAccess: state => state.user.profile.adminAccess,
      }),
    },
  mounted() {
    this.loadComponentData();
  },
};
</script>
